import React from "react";
import { Button } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";

export interface SettingsEditButtonProps {
  /** Enter edit mode. */
  onClick: () => void;
  /**
   * Mantine button variant, in brand teal. "filled" (default) for a surface's
   * main action; "outline" when another primary action shares the view
   * (e.g. a drawer whose header has "Add New Rate").
   */
  variant?: "filled" | "outline";
}

/**
 * The shared read-mode "Edit" affordance for a settings surface. Extracted so
 * the same button renders identically whether it sits in {@link SettingsTabShell}
 * (above the field rows) or is hoisted into a page header's `actions` slot
 * (e.g. GiftCardSettings). Keeping one source of the button means its styling
 * stays in lockstep across every placement.
 *
 * Styled as the brand-teal button used for header actions elsewhere (e.g.
 * PoliciesSettings) — `color="var(--brand-teal)"`, filled by default or
 * outlined.
 */
export default function SettingsEditButton({
  onClick,
  variant = "filled",
}: SettingsEditButtonProps) {
  return (
    <Button
      color="var(--brand-teal)"
      variant={variant}
      leftSection={<IconEdit size={16} />}
      onClick={onClick}
    >
      Edit
    </Button>
  );
}
